import React from 'react'
// import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { pure } from 'recompose'
import { useCommunity } from 'utils'
import { Link } from 'react-router'
import { ExternalLink } from 'components'
import { SIGN_IN_ROUTE } from 'config'

const propTypes = {}

const defaultProps = {}

function UpdateInfoNote() {
  const community = useCommunity()
  return (
    <section>
      <div className="content-block-container">
        <p className="neutral-callout">
          This arts partner has not yet entered information about its arts
          education programs and partnerships. If you're a staff member, please{' '}
          <Link to={SIGN_IN_ROUTE}>sign in</Link> to your account to update your
          profile. If you're unsure whether you have an account or need
          assistance, contact{' '}
          <ExternalLink href={`mailto:${community.partnerSupportEmail}`}>
            {community.partnerSupportEmail}
          </ExternalLink>
          .
        </p>
      </div>
    </section>
  )
}

UpdateInfoNote.propTypes = exact(propTypes)
UpdateInfoNote.defaultProps = defaultProps

export default pure(UpdateInfoNote)
